import apiClient from "./apiClient";


const technologies = [
  // Frontend
  { iconName: 'FaReact', name: 'React.js' },
  { iconName: 'FaHtml5', name: 'HTML5' },
  { iconName: 'FaCss3Alt', name: 'CSS3' },
  { iconName: 'SiJavascript', name: 'JavaScript' },
  { iconName: 'SiTypescript', name: 'TypeScript' },
  { iconName: 'SiNextdotjs', name: 'Next.js' },
  { iconName: 'SiRedux', name: 'Redux' },

  // Backend
  { iconName: 'FaNodeJs', name: 'Node.js' },
  { iconName: 'FaJava', name: 'Java' },
  { iconName: 'SiSpringboot', name: 'Spring Boot' },
  { iconName: 'SiExpress', name: 'Express.js' },
  { iconName: 'FaPython', name: 'Python' },
  { iconName: 'SiDjango', name: 'Django' },
  { iconName: 'SiFlask', name: 'Flask' },
  { iconName: 'SiPhp', name: 'PHP' },
  { iconName: 'SiLaravel', name: 'Laravel' },
  { iconName: 'SiCodeigniter', name: 'Codeigniter' },

  // Mobile
  { iconName: 'SiFlutter', name: 'Flutter' },
  { iconName: 'SiReact', name: 'React Native' },
  { iconName: 'SiKotlin', name: 'Kotlin' },
  { iconName: 'SiSwift', name: 'Swift' },

  // Databases
  { iconName: 'FaDatabase', name: 'MySQL' },
  { iconName: 'SiMongodb', name: 'MongoDB' },
  { iconName: 'SiPostgresql', name: 'PostgreSQL' },
  { iconName: 'SiFirebase', name: 'Firebase' },
  { iconName: 'SiRedis', name: 'Redis' },
  { iconName: 'SiSqlite', name: 'SQLite' },
  { iconName: 'SiOracle', name: 'Oracle' },

  // DevOps & Infrastructure
  { iconName: 'FaDocker', name: 'Docker' },
  { iconName: 'SiKubernetes', name: 'Kubernetes' },
  { iconName: 'FaAws', name: 'AWS' },
  { iconName: 'SiGooglecloud', name: 'GCP' },
  { iconName: 'VscAzure', name: 'Azure' },
  { iconName: 'SiJenkins', name: 'Jenkins' },
  { iconName: 'SiNginx', name: 'Nginx' },
  { iconName: 'SiApachetomcat', name: 'Apache Tomcat' },

  // Tools & Utilities
  { iconName: 'SiGit', name: 'Git' },
  { iconName: 'SiGithub', name: 'GitHub' },
  { iconName: 'SiBitbucket', name: 'Bitbucket' },
  { iconName: 'SiPostman', name: 'Postman' },

  // Others
  { iconName: 'SiGraphql', name: 'GraphQL' },
  { iconName: 'SiTailwindcss', name: 'Tailwind CSS' },
  { iconName: 'SiBootstrap', name: 'Bootstrap' },
  { iconName: 'SiJquery', name: 'jQuery' },
];


export const getTechnologies = async () => {
  try {
    const response = await apiClient.get("/technologies");
    return response.data;
  } catch (error) {
      console.error("Error fetching technologies:", error);
      //throw error; // rethrow so component can handle it
      return technologies;
  }
};
